import React from 'react';
import { Modal, List, Button, WhiteSpace, WingBlank, Icon } from 'antd-mobile';
import './index.css';
import axios from 'axios';
import userRequest, {userApi} from 'common/request';

class IdentifyModal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            title:'人脸身份认证',
            modal1: false,
            modal2: false,
            left: {},
            right: {},
            leftCover: {},
            rightCover: {},
            count: ''
        }
    }

    sleep(t){
        return new Promise(function(resolve){
            setTimeout(resolve, t);
        })
    }

    async transformCicle(){
        for(let i = 0; i < 31; i++) {
            if(i < 16){
                this.setState(() => {return {count: (30-i)}})
                this.setState(() => {return {right: {transform: `rotate(${i*(-6)}deg)` }}})
                this.setState(() => {return {left: {transform: `rotate(${i*(6)}deg)` }}})
                await this.sleep(1000);
            }else{
                this.setState(() => {return {left: {transform: `rotate(${i*(6)}deg)` }}})
                this.setState(() => {return {right: {transform: `rotate(${i*(-6)}deg)`}}})
                this.setState(() => {return {rightCover: {display: `inline-block`, transform: `rotate(${(i-15)*(-6)}deg)`}}})
                this.setState(() => {return {leftCover: {display: `inline-block`, transform: `rotate(${(i-15)*6}deg)`}}})
                this.setState(() => {return{count: (30-i)}})
                await this.sleep(1000);
            }
        }
        this.showModal('modal2')();
        this.jumpTo('yes')
        this.setState({right: {transform: `rotate(0deg)` }})
        this.setState({left: {transform: `rotate(0deg)` }})
        this.setState({rightCover: {display: `none`, transform: `rotate(0deg)`}})
        this.setState({leftCover: {display: `none`, transform: `rotate(0deg)`}})
        this.setState({count: 30})
    }

    showModal = key => (e) => {
        // e.preventDefault(); // 修复 Android 上点击穿透
        console.log(key)
        this.setState({
            [key]: true,
        });
        // if(key == 'modal1') {
        //     this.transformCicle()
        // }
    }

    onClose = key => (e) => {
        console.log(key)
        this.setState({
          [key]: false,
        });
        if(key == "modal2") {
            console.log(decodeURIComponent(this.props.match.params.courseid))
            document.location.replace(decodeURIComponent(this.props.match.params.location))
        }
    }

    getCookie(name){
        let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
        if (arr = document.cookie.match(reg)) return unescape(arr[2])
        else return null
    }
    
    async jumpTo(timeout) {
        if (this.props.match.params) {
        let token = this.getCookie('_token')
        let pattern=/{i:\d+;s:\d+:"_token";i:\d+;s:\d+:"(.+?)";}/
        token = pattern.exec(decodeURIComponent(token))
        token = token?`${token[1]}`: ''
      
        let sid = this.props.match.params.sid

        let ua = navigator.userAgent.toLowerCase();
		let isWeixin = ua.indexOf('micromessenger') != -1;
        let dataParams= isWeixin ? {
            'sub_id': sid,
            'timeout': timeout,
            'forward': decodeURIComponent(this.props.match.params.location),
            'type': 'wechat'
        } : {
            'sub_id': sid,
            'timeout': timeout,
            'forward':decodeURIComponent(this.props.match.params.location),
            'type': 'H5'
        };
        return await axios({
            method: 'post',
            url: userApi.secondIdentify,
            // params: { 'sub_id': sid,
            //     'timeout': 'no',
            //     'forward': window.location.href },
            data: dataParams,
            timeout: 10000,
            headers: {
               'Authorization': `${token}`,
               'Content-Type': 'application/json'
            }
        }).then(async response => {
            console.log(response)
            if(response.response !== undefined && (response.response.status !== 200 || 
                response.response.status !== 304 || response.response.status !== 400)) {
                alert(response.response.data.msg)
            }

            if (response!==undefined && ((response.status === 200 || response.status === 304 || response.status === 400))) {
                // return response.data // 直接返回http response响应的data,此data会后端返回的数据数据对象，包含后端自定义的code,message,data属性
                if(response.data.code !== undefined && response.data.code == 0 &&
                    response.data.data !== undefined && response.data.data.length > 0 ){
                        // window.location = response.data.data
                        document.location.replace(response.data.data);
                }else {
                    // const initData = {
                    //     username: JSON.parse(localStorage.getItem('userinfo')).user_name,
                    //     tenant_code: String(localStorage.getItem('tenant_code')),
                    //     update_at: +String(parseInt(Date.now() / 1000))
                    // }        
                    // await userRequest.postRequest( window.AppConfig.courseHost + userApi.recordCreate, {course_id: String(this.props.match.params.courseid), course_subject_id: String(this.props.match.params.sid), type: 'learn_time', learn_time: 0,
                    // play_time: parseInt(0), ...initData}).then(res => {
                    //     console.log(res)
                    // }).catch(err => { })
                    if(timeout !== "yes") {
                        alert(response.data.msg)
                    }
                }
            }
        }).catch(err => {
            console.log(err)
        })
        }
    }

    hello() {
        alert('hello')
    }

    componentWillMount() {
        this.transformCicle()
    }

    render(){
        return (
            <div>
            {/* <Modal
            visible={this.state.modal1}
            transparent
            maskClosable={false}
            onClose={this.onClose('modal1')}
            title="人脸身份认证"
            // footer={[{ text: 'Ok', onPress: () => { console.log('ok'); this.onClose('modal1')(); } }]}
            // wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            // afterClose={() => { alert('afterClose'); }}
            style={{height: '90%', position: 'sticky'}}
            > */}
            <div style={{ height: '90%', overflow: 'scroll' }}>
                <div className="co-tips" style={{ textAlign:'left' }}>
                    <span className="co-des-title">温馨提示：</span>
                    <span className="co-tips-text">
                        1、为确认培训有效性，进入平台前，您需要进行人脸识别身份认证，确认为本人进行学习。
                    </span>
                    <span className="co-tips-text">
                        2、人脸识别认证只能使用居民身份证，认证前请先确保身份证号无误。
                    </span>
                    <span className="co-tips-text">
                        3、本次认证结果很重要，请认真对待。
                    </span>
                </div>
                <div className="co-condition">
                    <div className="co-condition-img">
                        <div>
                            <div className="co-condition-block">
                                <img className="co-confirm-img"
                                src={require('./image/确认.png')}></img>
                                <img src={require('./image/手机.png')}></img>
                            </div>
                            <div className="co-condition-text">正对手机</div>
                        </div>
                        <div>
                            <div className="co-condition-block">
                            <img className="co-confirm-img"
                                src={require('./image/确认.png')}></img>
                            <img src={require('./image/灯泡.png')}></img>
                            </div>
                            <div className="co-condition-text">光线充足</div>
                        </div>
                        <div>
                            <div className="co-condition-block">
                            <img className="co-confirm-img"
                                src={require('./image/确认.png')}></img>
                                <img src={require('./image/时钟.png')}></img>
                            </div>
                            <div className="co-condition-text">放慢动作</div>
                        </div>
                    </div>
                    <div className="co-portrait">
                        <div className="count-time">
                            <div id="left" style={this.state.left}></div>
                            <div id="count">{this.state.count}</div>

                            <div id="right" style={this.state.right}></div>

                            <div id="right-cover" style={this.state.rightCover}></div>

                            <div id="left-cover" style={this.state.leftCover}></div>
                        </div>
                        {/* this.jumpTo('no') */}
                        <Button id="co-submit-identify" onClick={() => {this.jumpTo('no')}} style={{margin: "1rem auto"}}  activeStyle={{opacity: 0.5}}>开始人脸识别</Button>
                        <span style={{ color: "#ADADAD"}}>请及时进入人脸验身，若倒计时结束前未及时验证，本次验证结果将自动判断为失败。</span>
                    </div>
                </div>
            </div>
            {/* </Modal> */}

            <Modal
            visible={this.state.modal2}
            transparent
            maskClosable={false}
            // onClose={this.onClose('modal2')}
            title="人脸身份认证"
            // footer={[{ text: 'Ok', onPress: () => { console.log('ok'); this.onClose('modal1')(); } }]}
            // wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            // afterClose={() => { alert('afterClose'); }}
            style={{ position: 'sticky'}}>
                <div style={{ height: '90%', overflow: 'scroll' }}>
                    <div className="condition">
                        <img src={require('./image/error.png')} className="error-img margin"></img>
                        <span className="co-des-title margin">认证失败</span>
                        <span className="co-tips-text margin">人脸身份认证未及时响应，本次认证失败</span>
                        <button className="submit-return" onClick={this.onClose('modal2')}>返回</button>
                    </div>
                </div>
            </Modal>
            </div>
        )
    }
}

export default IdentifyModal;